import { newGuid } from "../../constant";
import { Observable } from "rxjs";

export type IValidationErrors = string[] | null;

export class ComponentSaver {
    constructor(public displayName: string, public validate: (sp: SaveProgress) => IValidationErrors, public save: (sp: SaveProgress) => Observable<any> | IValidationErrors) {
        this.id = newGuid();
    }
    id: string;
}

export class SaveProgress {
    constructor(savers: ComponentSaver[]) {
        this.state = null;
        this.progress = savers.map(item => ({
            id: item.id,
            displayName: item.displayName,
            isValid: null,
            isSaved: null,
            errors: null
        }));
    }
    state: 'validation' | 'inprogress' | 'complete' | 'error';

    progress: { id: string, displayName: string, isValid: boolean, isSaved: boolean, errors: IValidationErrors } [];

    isAllValid(): boolean {
        return this.progress.find( item => item.isValid == false ) == null;
    }

    setValidState(id: string, errors: IValidationErrors) {
        const item = this.progress.find(x => x.id == id);
        if (item == null ) throw `${id} is not found`;
        item.isValid = errors == null || errors.length == 0;
        item.errors = errors;
    }

    setSaveState(id: string, errors: IValidationErrors) {
        const item = this.progress.find(x => x.id == id);
        if (item == null ) throw `${id} is not found`;
        item.isSaved = errors == null || errors.length == 0;
        item.errors = errors;
    }
}